module.exports = __webpack_public_path__ + "static/media/flow-es.e0691bf6.png";